import produce from 'immer';
import TAppActions, { IAppState, IGlobalLoader } from '../../types/redux/app';
import { TOGGLE_GLOBAL_LOADING } from '../actions/app';

const filterGlobalLoaders = (state: IAppState, loader: IGlobalLoader): IGlobalLoader[] => produce(state.globalLoaders, (draft) => {
    if (!loader.loading) {
        const index = draft.findIndex((item) => item.title === loader.title);
        draft.splice(index, 1);
    } else if (typeof draft.find((item) => item.title === loader.title) === 'undefined') {
        draft.push(loader);
    }
});

const initialState: IAppState = {
    globalLoaders: [],
};

export const app = (state = initialState, action: TAppActions): IAppState => {
    switch (action.type) {
        case TOGGLE_GLOBAL_LOADING: {
            return {
                ...state,
                globalLoaders: filterGlobalLoaders(state, action.payload),
            };
        }
        default: {
            return state;
        }
    }
};
